import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { Usuario } from '../models/usuario.model';
import { TokenStorageService } from './token-storage.service';

export const OAUTH_CONFIG: AuthConfig = {
    issuer: `${environment.sso_url}`,
    redirectUri: `${environment.sso_redirect_uri}`,
    clientId: `${environment.sso_client_id}`,
    responseType: 'code',
    showDebugInformation: false,
    scope: 'openid profile',
    requireHttps: false,
};

@Injectable({
    providedIn: 'root',
})
export class AuthService {

    user: Subject<Usuario> = new Subject<Usuario>();

    constructor(
        private oauthService: OAuthService,
        private tokenStorage: TokenStorageService
    ) {}

    login(): void {
        this.oauthService.configure(OAUTH_CONFIG);
        // Onda 6: sessionStorage em vez de localStorage (M-05)
        this.oauthService.setStorage(this.tokenStorage.getStorage());
        this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
            this.oauthService.tryLogin().then(() => {
                if (!this.oauthService.hasValidAccessToken()) {
                    this.oauthService.initLoginFlow();
                } else {
                    this.oauthService.setupAutomaticSilentRefresh();
                    this.oauthService.loadUserProfile().then((up) => {
                        this.user.next({
                            name: up?.given_name?.substr(8).trim(),
                            cpf: up?.given_name?.substr(0, 8).trim(),
                        });
                    }).catch(reason => {
                        console.log("LoadUserProfile failed");
                        this.oauthService.initLoginFlow();
                    });
                }
            }).catch(reason => {
                console.log("TryLogin failed");
                this.oauthService.initLoginFlow();
            });
        }).catch(reason => {
            console.log("LoadDiscoveryDocumentAndTryLogin failed");
            console.log(reason);
            this.oauthService.initLoginFlow();
        });
    }

    getUser(): Observable<Usuario> {
        return this.user;
    }

    logout() {
        this.oauthService.logOut();
        this.tokenStorage.clear();
    }
}
